<div class="bg-white border m-1 pt-2 pb-1 px-3 d-flex flex-column shadow-sm"
     [attr.data-testid]="'device-grid-item-' + device()?.serialNumber"
     [class.active]="isSelected()"
     [class.checkedin]="isInUse() === true"
     [class.checkedout]="isInUse() === false">
  <div class="d-flex align-items-center pb-1">
    @if (device()?.roomCategoryId) {
      <div class="border-end pe-2 me-2 align-self-stretch d-flex">
        <era-room-number [categoryId]="$safeNavigationMigration(device()?.roomCategoryId)"
                         class="align-self-center"></era-room-number>
      </div>
    }
    <div class="flex-grow-1 lh-1">
      <strong class="text-primary">{{ device()?.name || device()?.udid }}</strong><br />
      <small class="font-monospace">{{ device()?.serialNumber || 'more info' }}</small>
    </div>
    @if (isOver24Hours || isOver48Hours) {
      <fa-icon [icon]="['far', 'clock']"
               class="ms-3"
               [class.text-warning]="isOver24Hours"
               [class.text-danger]="isOver48Hours"
               [ngbTooltip]="$safeNavigationMigration(device()?.lastSeen) | date: 'medium'"></fa-icon>
    }
    @if (hasWarning() && !(isOver24Hours || isOver48Hours)) {
      <fa-icon [icon]="['fas', 'exclamation-triangle']"
               class="ms-3 text-warning"
               [ngbTooltip]="'Device is out of sync'"></fa-icon>
    }
    @if (device()?.apple?.modelName[0] === 'AppleTV') {
      <fa-icon [icon]="['fas', 'tv']"
               size="lg"
               class="ms-3"
               [ngbTooltip]="'Apple TV'"></fa-icon>
    } @else if (device()?.apple?.modelName[0] === 'iPad') {
      <fa-icon [icon]="['fas', 'tablet-alt']"
               size="lg"
               class="ms-3"
               [ngbTooltip]="'iPad'"></fa-icon>
    } @else if (device()?.apple?.modelName[0] === 'iPhone') {
      <fa-icon [icon]="['fas', 'mobile-alt']"
               size="lg"
               class="ms-3"
               [ngbTooltip]="'iPhone'"></fa-icon>
    }
    @if (!!osUpdateStatus()?.overviewState && osUpdateStatus()?.overviewState === 'Failed') {
      <fa-icon [icon]="['fas', 'exclamation-triangle']"
               [ngbTooltip]="'OS update failed'"
               class="ms-3"></fa-icon>
    } @else if (!!osUpdateStatus()?.overviewState && osUpdateStatus()?.overviewState === 'Busy') {
      <fa-icon [icon]="['fas', 'arrow-circle-up']"
               [ngbTooltip]="$safeNavigationMigration(osUpdateStatus()?.overviewState)"
               class="ms-3 text-warning"></fa-icon>
    }
    <!-- TODO: We should have an alternative working solution to show the pause icon -->
    <!-- <fa-icon *ngIf="!isApplicationInSync && isCheckedIn && !isOver24Hours && !isOver48Hours && !hasWarning"
    [icon]="['fas', 'pause']"
    size="lg"
    class="ms-3"
  [ngbTooltip]="'Application update is paused because room is checked-in or it is a room level override'"></fa-icon> -->
  </div>
</div>